import { useState } from 'react'
import { MilitaryHearingLossFormState } from '../../hooks/useMilitaryHearingLossForm/useMilitaryHearingLossForm'
import { buildPayload } from '../../hooks/useMilitaryHearingLossForm/militaryHearingLossFormUtils'
import styles from './PayloadDebugPanel.module.scss'

interface Props {
    form: MilitaryHearingLossFormState
    agentLabel: string
}

export const PayloadDebugPanel = ({ form, agentLabel }: Props) => {
    const [open, setOpen] = useState(false)
    const [copied, setCopied] = useState(false)

    const payload = buildPayload(form, agentLabel)
    const json = JSON.stringify(payload, null, 2)

    const handleCopy = () => {
        navigator.clipboard.writeText(json).then(() => {
            setCopied(true)
            setTimeout(() => setCopied(false), 1500)
        })
    }

    return (
        <div className={`${styles.panel} ${open ? styles.open : ''}`}>
            <button
                type="button"
                className={styles.toggle}
                onClick={() => setOpen((o) => !o)}
                title="Toggle payload inspector"
            >
                <span className={styles.badge}>DEV</span>
                {open ? '✕ Close' : '{ } Payload'}
            </button>

            {open && (
                <div className={styles.body}>
                    <div className={styles.header}>
                        <span className={styles.title}>Live Payload</span>
                        <button type="button" className={styles.copyBtn} onClick={handleCopy}>
                            {copied ? '✓ Copied' : 'Copy'}
                        </button>
                    </div>
                    <pre className={styles.pre}>{json}</pre>
                </div>
            )}
        </div>
    )
}
